import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import FilterCustom from "./Filter"
import ViewSaleDetailModal from "../Modal/DetailModal"

function ListSale({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
  setExcelKeyword,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setParentFilter(filter)
    setExcelKeyword(keyword)
    try {
      const res = await ReportsService.getListSaleB2B({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        console.log("API trả về:", res.success.data)

        const formatted = res.success.data.map((item, index) => {
          // Tính tổng giá trong detail của toàn bộ history
          const totalDetailPrice =
            item.history?.reduce((sum, h) => {
              return (
                sum +
                (h.details?.reduce((dSum, d) => {
                  const price = Number(
                    d?.sim_parent?.history?.sim_unit_price ?? 0,
                  )
                  return dSum + price
                }, 0) || 0)
              )
            }, 0) || 0

          return {
            ID: item.ID,
            key: item.ID || index,
            export_code: item.export_code || "",
            customer: item.customer || null,
            sim_quantity: item.sim_quantity || 0,
            data_quantity: item.data_quantity || 0,
            approved_export_at: item.approved_export_at || "",
            total_amount: item.total_amount
              ? Number(item.total_amount).toLocaleString()
              : "0",
            total_discount: item.total_discount
              ? Number(item.total_discount).toLocaleString()
              : "0",
            profit: (
              Number(item.total_amount) - Number(totalDetailPrice)
            ).toLocaleString(),
            createby: item.createby || null,
            created_at: item.created_at || "",
            approved_person: item.approved_export_by?.fullname || "",
            sale_type: item.sale_type === "0" ? "Bán buôn" : "Bán lẻ",
            sim_type: item.sim_type == 1 ? "Sim vật lý" : item.sim_type == 2 ? "E-SIM" : "",

            // 👇 thêm field tổng giá detail
            total_detail_price: totalDetailPrice.toLocaleString(),
          }
        })

        setDataSource(formatted)
        setSummary({
          total_sim: Number(res?.success?.sim?.total_sim || 0).toLocaleString(
            "en-US",
            { maximumFractionDigits: 0 },
          ),
          total_amount: Number(
            res?.success?.sim?.total_amount || 0,
          ).toLocaleString("en-US", { maximumFractionDigits: 0 }),
          total_discount: Number(
            res?.success?.sim?.total_discount || 0,
          ).toLocaleString("en-US", { maximumFractionDigits: 0 }),
          total_profit: Number(
            res?.success?.sim?.total_profit || 0,
          ).toLocaleString("en-US", { maximumFractionDigits: 0 }),
        })

        setPagination({
          ...pagination,
          total: res.success.total,
        })
      }
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  useEffect(() => {
    setPagination({
      ...pagination,
      current: 1,
    })
  }, [filter])

  const column = [
    {
      title: "Mã đơn hàng",
      dataIndex: "export_code",
      align: "center",
    },
    {
      title: "Khách hàng",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    {
      title: "Loại giao dịch",
      dataIndex: "sale_type",
      align: "center",
    },
    // {
    //   title: "Loại SIM",
    //   dataIndex: "sim_quantity",
    //   key: "sim_quantity",
    // },
    {
      title: "Số lượng SIM",
      dataIndex: "sim_quantity",
      key: "sim_quantity",
      align: "center",
    },
    {
      title: "Loại SIM",
      dataIndex: "sim_type",
      key: "sim_type",
      align: "center",
    },

    // {
    //   title: "Đơn giá SIM",
    //   dataIndex: "sim_unit_price",
    //   key: "sim_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    // {
    //   title: "Dung lượng Data",
    //   dataIndex: "data_quantity",
    //   key: "data_quantity",
    //   align: "center",
    // },
    // {
    //   title: "Đơn giá data",
    //   dataIndex: "data_unit_price",
    //   key: "data_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Tổng tiền nhập",
      dataIndex: "total_detail_price",
      key: "total_detail_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền bán",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Lợi nhuận",
      dataIndex: "profit",
      key: "profit",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    // {
    //   title: "Người tạo",
    //   dataIndex: "createby",
    //   key: "createby",
    //   render: createby => createby?.fullname || "",
    //   align: "center",
    // },
    {
      title: "Ngày duyệt xuất kho",
      dataIndex: "approved_export_at",
      key: "approved_export_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
    // {
    //   title: "Người duyệt",
    //   dataIndex: "approved_person",
    //   key: "approved_person",
    //   align: "center",
    // },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  const handleRowClick = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false)
    setSelectedRecord(null)
  }
  return (
    <div>
      <div style={{ display: "flex" }}>
        <FilterCustom
          setFilter={setFilter}
          setKeyword={setKeyword}
          // tabStatus={tabStatus}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng số SIM: {summary?.total_sim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>Tổng tiền bán: {summary?.total_amount}</strong>
        </div>
        {/* <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tổng tiền sau chiết khấu: {summary?.total_discount}</strong>
        </div> */}
        <div
          style={{ padding: "0 5px", color: "#462cdbff", minWidth: "150px" }}
        >
          <strong>Lợi nhuận: {summary?.total_profit}</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={column}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              handleRowClick(record?.ID)
            },
          }
        }}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {selectedRecord && (
        <ViewSaleDetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseDetailModal}
          recordId={selectedRecord}
        />
      )}
    </div>
  )
}

export default ListSale
